<template>
  <div>
    <Head :title="`${form.user.first_name} ${form.user.last_name}`" />
    <div class="mb-8 flex w-full justify-start">
      <h1 class="text-3xl font-bold">
        <Link
          class="text-indigo-500 hover:text-indigo-600"
          :href="$routes.users()"
        >
          Użytkownicy
        </Link>
        <span class="font-medium text-indigo-400">/</span>
        {{ form.user.first_name }} {{ form.user.last_name }}
      </h1>
      <img
        v-if="user.photo"
        class="ml-4 block h-8 w-8 rounded-full"
        :src="user.photo"
        alt="Zdjęcie"
      >
    </div>
    <div class="w-full overflow-hidden rounded-sm bg-white shadow-sm">
      <user-form v-model="form" @submit="submit">
        <div
          v-if="can.edit_user"
          class="flex items-center border-t border-gray-200 bg-gray-100 px-8 py-4"
        >
          <button
            class="btn-action-delete"
            type="button"
            title="Usuń"
            @click="destroy"
          >
            <icon name="trash" class="mr-1.5 h-3.5 w-3.5 stroke-current" />
            Usuń użytkownika
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit"
          >
            Zapisz zmiany
          </loading-button>
        </div>
      </user-form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import Layout from '@/Layouts/Admin.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import UserForm from './Form.vue';

export default {
  components: {
    Head,
    Link,
    Icon,
    LoadingButton,
    UserForm,
  },
  layout: Layout,
  props: {
    user: {
      type: Object,
      required: true,
    },
    can: {
      type: Object,
      required: true,
    },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        user: {
          ...this.user,
          photo: null,
        },
      }),
    };
  },
  methods: {
    submit() {
      this.form.put(this.$routes.user(this.user.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      });
    },
    destroy() {
      if (confirm('Czy na pewno chcesz usunąć tego użytkownika?')) {
        this.$inertia.delete(this.$routes.user(this.user.id));
      }
    },
  },
};
</script>
